// socket.js
import { io } from 'socket.io-client';

const socket = io(process.env.REACT_APP_BACKEND_URL, {
  reconnection: true,
  reconnectionDelay: 1000,
  reconnectionDelayMax: 5000
});

export default socket;
